import type { MouseEvent, ReactNode } from 'react'
import { Icon } from './icon'
import { T } from '../data/mock'

type StatusKey = keyof typeof T.status

const toneMap: Record<StatusKey, 'success' | 'warning' | 'danger' | 'info' | 'neutral'> = {
  paid: 'success',
  due_soon: 'warning',
  overdue: 'danger',
  draft: 'info',
  archived: 'neutral',
  active: 'success',
  ok: 'success',
  gap: 'warning',
  debt: 'warning',
  purchased: 'success',
  expired: 'danger',
}

export function StatusChip({ status }: { status: StatusKey | string }) {
  const tone = toneMap[status as StatusKey] ?? 'neutral'
  const label = (T.status as Record<string, string>)[status] ?? status
  return (
    <span className={`chip ${tone === 'neutral' ? '' : tone}`}>
      {tone !== 'neutral' && <span className="chip-dot" />}
      {label}
    </span>
  )
}

type FilterChipProps = {
  label: string
  value?: ReactNode
  onClear?: () => void
  onClick?: () => void
  active?: boolean
}

export function FilterChip({ label, value, onClear, onClick, active }: FilterChipProps) {
  const hasValue = value !== undefined && value !== null && value !== ''
  return (
    <button
      type="button"
      className={`filter-chip ${hasValue ? 'has-value' : ''} ${active ? 'is-active' : ''}`}
      onClick={onClick}
    >
      <span style={{ color: 'var(--fg-3)' }}>{label}</span>
      {hasValue && <span>{value}</span>}
      {!hasValue && <Icon name="chevron-down" size={12} />}
      {hasValue && onClear && (
        <span
          className="lucide close"
          role="button"
          aria-label="Очистити"
          tabIndex={0}
          onClick={(e: MouseEvent) => {
            e.stopPropagation()
            onClear()
          }}
          style={{ cursor: 'pointer', display: 'inline-flex' }}
        >
          <Icon name="x" size={12} />
        </span>
      )}
    </button>
  )
}
